// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 696) return "static/chunks/696-7c7c37b22226528c5dd5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"294":"94a00edbc73c12d51f5c","752":"0a5d2656439cc6b33df3"}[chunkId] + ".js";
};